





























import Vue from "vue";

import { state } from "./data/state";
import { computed, onMounted } from "@vue/composition-api";
import { SharedState } from "@/common/state";
import TrustedHeader from "./TrustedHeader.vue";
import { POPULATION_TYPE } from "@/common/models";
import NavBar from "./Navbar.vue";
import TableSection from "./TableSection.vue";
import PageWithMainContainer from "@/components/PageWithMainContainer.vue";

export default Vue.extend({
  components: {
    TrustedHeader,
    NavBar,
    TableSection,
    PageWithMainContainer,
  },
  setup(_, { root: { $router } }) {
    const {
      is_loading_all,
      selected_info_type,
      selected_virtual_label,
      selected_sensitivity_level,
      selected_entity_type,
      query,
      current_display_list,
      current_display_list_without_filtering,
      is_filter_changed,
      on_filters_updated,
    } = state;

    const title = computed(() => {
      switch (selected_entity_type.value.id) {
        case POPULATION_TYPE.EMPLOYEE:
          return "Manage trust of employees";
        case POPULATION_TYPE.ORGANIZATION:
          return "Manage trust of organizations";
        case POPULATION_TYPE.PRIVATE_EMAIL:
          return "Manage trust of personal contacts";
        case POPULATION_TYPE.DEPARTMENT:
          return "Manage trust of departments";
      }
    });

    onMounted(() => {
      SharedState.onReady(async () => {
        const { entity, label, sensitivity } = $router.currentRoute.query;
        await state.init({
          entity_type: entity as POPULATION_TYPE,
          info_type_id: label as string,
          sensitivity_level: sensitivity ? +sensitivity : 3,
        });
      });
    });

    const has_no_results = computed(
      () =>
        !is_loading_all.value &&
        current_display_list_without_filtering.value.length === 0
    );

    const update_filters = async () => {
      await on_filters_updated();
    };

    return {
      title,
      query,
      is_loading_all,
      selected_info_type,
      selected_virtual_label,
      selected_sensitivity_level,
      selected_entity_type,
      current_display_list,
      has_no_results,
      is_filter_changed,
      update_filters,
    };
  },
});
